<div class="consignment-popup">
  <div class="popup-header">
    <div class="title">{{ 'Consignment.Consignment' | translate}}</div>
    <div class="item-name"> {{ data?.itemName }} </div>
    <div class="summary">
      <div class="summary-item"> {{ 'Consignment.QtyRequired' | translate}} <strong>{{ qtyRequired }}</strong></div>
      <div class="summary-item"> {{ 'Consignment.QtySelected' | translate}} <strong>{{ totalSelected }}</strong></div>
      <div class="summary-item"> {{ 'Consignment.QtyRemaining' | translate}} <strong [ngClass]="{'over-selected': qtyRemaining !== 0}">{{ qtyRemaining }}</strong></div>
    </div>
  </div>

  <div class="grid">
    <cdk-virtual-scroll-viewport itemSize="50" class="viewport">
      @if (batches?.length > 0) {
      <div *cdkVirtualFor="let batch of batches; let i = index" class="table-row card">
        <div class="card-inner">
          <div class="card-row row-top">
            <div class="field">
              <div class="field-label"> {{ 'Consignment.BatchNo' | translate}} </div>
              <div class="field-value">{{ batch.BatchNo }}</div>
            </div>
            <div class="field">
              <div class="field-label"> {{ 'Consignment.BatchName' | translate}} </div>
              <div class="field-value">{{ batch.BatchName }}</div>
            </div>
          </div>

          <div class="card-row row-bottom">
            <div class="field">
              <div class="field-label">{{ 'Consignment.BatchQOH' | translate}}</div>
              <div class="field-value">{{ batch.CurrentQOH }}</div>
            </div>
            <div class="field">
              <label class="field-label" for="selectedQty-{{i}}"> {{ 'Consignment.SelectedQTY' | translate}}</label>
              <div class="field-value field-input" [class.invalid]="batch.invalid">
                <input id="selectedQty-{{i}}" type="number" min="0" [max]="batch.CurrentQOH" [value]="batch.selectedQty || 0"
                  (input)="onQtyInput($event, batch)" />
              </div>
            </div>
          </div>
        </div>
      </div>
    }
      @if (batches?.length === 0) {
      <app-no-items [addNewClass]="noDataFullScreen"></app-no-items>
      }
    </cdk-virtual-scroll-viewport>
  </div>

  <div class="footer">
    <button mat-button (click)="close()"> {{ 'Consignment.Cancel' | translate}} </button>
    <button mat-button (click)="clearAll()"> {{ 'Consignment.ClearAll' | translate}}</button>
    <button mat-raised-button color="primary" (click)="save()"> {{ 'Consignment.Save' | translate}}</button>
  </div>
</div>
<app-toast-message [show]='toastShow' [message]="toastMessage" [buttonText]='buttonText'
  (ToastDismiss)='($event)' (AutoDismiss)='toastAutoDismiss($event)'>
</app-toast-message>